import {AfterViewInit, ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, viewChild} from '@angular/core';
import {WjChartAnalyticsModule, WjFlexChartWaterfall} from '@mescius/wijmo.angular2.chart.analytics';
import {WjChartModule} from '@mescius/wijmo.angular2.chart';
import {Wijmo} from '../lib/wjgrid-utils';
import {Globalize} from '@mescius/wijmo';
import {HitTestInfo} from '@mescius/wijmo.chart';
import {WjCharts} from '../lib/wjcharts';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjChartAnalyticsModule,
        WjChartModule
    ],
    template: `
        <div class="layout-vbox" style="gap: 10px">
            <div>Waterfall Chart</div>
            <wj-flex-chart bindingX="name"
                           header="Walk from NLR to Target LR (UWY)"
                           style="width: 650px; height: 700px">
                <wj-flex-chart-axis wjProperty="axisY" [axisLine]="true" format="n0" [min]="0.00">
                </wj-flex-chart-axis>

                <wj-flex-chart-axis wjProperty="axisX" [labelAngle]="-45"
                                    [overlappingLabels]="Wijmo.OverlappingLabels.Show" [labelPadding]="10">
                </wj-flex-chart-axis>

                <wj-flex-chart-waterfall #wfc name="" binding="value" [styles]="styles" [connectorLines]="false"
                                         [showIntermediateTotal]="false"
                                         [showTotal]="false" totalLabel="Plan LR" [relativeData]="true">
                </wj-flex-chart-waterfall>

                <wj-flex-chart-data-label [position]="Wijmo.LabelPosition.Top" content="{label}"></wj-flex-chart-data-label>
            </wj-flex-chart>
            <div class="toolbar-horizontal">
                <fluent-button>Add</fluent-button>
                <fluent-button>Dump</fluent-button>
                <fluent-button>Trigger Tooltip</fluent-button>
            </div>
        </div>
    `,
    styles: `
    `
})
export class TestWaterfallChartComponent implements AfterViewInit {

    protected readonly styles = WjCharts.GeneraliWaterfallChartStyle;
    protected readonly Wijmo = Wijmo;

    private readonly chart = viewChild<WjFlexChartWaterfall>(WjFlexChartWaterfall);

    protected data = [
        { name: "Expiring Premum YTD", value: 55.7, label: '' },
        { name: "Premium decrease due to lost Accounts", value: -2.0 },
        { name: "Premium change due to Exposure variation", value: -4.3 },
        { name: "Premium change due to ERC", value: 2.4, isFollowedByTotal: 'Renewed Premium' },
        // { name: "Renewed Premium", value: 51.7, isTotal: true },
        { name: "New Businees YTD", value: 24.3, isFollowedByTotal: "Total Renewed Premium" },
        //{ name: "Total Renewed Premium", value:  76.0, isTotal: true },
        { name: "Remaining Target Premium including New Business", value: 138.4, isFollowedByTotal: "Estimated Premium at YE" },
        //{ name: "Estimated Premium at YE", value: 214.4, isTotal: true },
    ]

    protected data2 = [
        { name: "2025 NLR ", value: 0.696126216 },
        { name: "Protect", value: 0.704725964 },
        { name: "Improve", value: 0.694674004 },
        { name: "Lose", value: 0.687699634 },
        { name: "Key Accounts", value: 0.687401394 },
        { name: "Not Renewable", value: 0.68740767 },
        { name: "Total ex. New Business", value: 0.68740767 },
        { name: "New Business", value: 0.687692552 },
    ]

    constructor() {
    }

    async ngAfterViewInit(): Promise<void> {
        await this.doIt();
    }

    async doIt() {
        const chart = this.chart();
        const data = this.data;
        data.forEach(it => it.label = Globalize.format(it.value, 'n1'));

        const chartData = data;
        const totals = chartData
            .map((item, index) => ({ item, index }))
            .filter(it => it.item.isFollowedByTotal);

        const totalPositions = totals.map(it => it.index + 1);
        const totalLabels = totals.map(it => it.item.isFollowedByTotal);

        if (chart == null) {
            console.log('!!!!!!!!!!!!!!No chart found');
        } else {
            chart.tooltipContent = (hti: HitTestInfo) => {
                const item = hti.item;
                // console.log(hti);
                return `${hti.x}: ${Globalize.format(hti.y, 'n1')}`
            }
            chart.chart.itemsSource = chartData;
            chart.intermediateTotalPositions = totalPositions;
            chart.intermediateTotalLabels = totalLabels;
            chart.showIntermediateTotal = true;
            chart.totalLabel = '**Total';
        }
    }
}
